import Vue from 'vue'

export default {
    install() {
        //保留两位小数，非四舍五入
        Vue.prototype.mathFloorTowPoint = (num) => Math.floor(num * 100) / 100;
        //判断值是否为null或者undefined或者""
        Vue.prototype.isExest = (useVal) => {
            if (useVal == null || useVal == undefined || useVal == "") {
                return false;
            } else {
                return true;
            }
        }
        //json字符串转换json数组
        Vue.prototype.jsonStrToJsonArray = (str) => {
          var isString = typeof(str)=='string';
            try {
                if (str != undefined && str != null && str != '') {
                    if(isString){
                        return JSON.parse(str);
                    }else{
                        return JSON.parse(JSON.stringify(str));
                    }
                } else {
                    return [];
                }
            }catch (e) {
                console.log(e);
                return [];
            }
        }
      //获取今日日期(yyyy-mm-dd)
      Vue.prototype.getTodayForSearch = () => {
        var myDate = new Date();
        return myDate.getFullYear()+"-"+(myDate.getMonth()+1)+"-"+myDate.getDate();
      }
    }
}



// WEBPACK FOOTER //
// ./src/tools.js